
import Injection = EECore.Injection;

export const SITECORE_API_KEY = "{BBEC7EE2-E0B1-4041-90F4-80CA08BACE59}";

@Injection.injectableClass("EEWidget.DocumentCentreSearchService")
export default class SearchService {

  @Injection.injectableProperty("EEWidget.DocumentCentreSearchService", EECore.Registrations.LOCATION)
  private location: Location;

  @Injection.injectableProperty("EEWidget.DocumentCentreSearchService", EECore.Registrations.CONTENT_SERVICE_HELPER)
  private contentServiceHelper: EECore.Helpers.ContentServiceHelper;

  @Injection.injectableProperty("EEWidget.DocumentCentreSearchService", EECore.Registrations.HTTP_CLIENT)
  private httpClient: EECore.HttpClient;

  @Injection.injectableProperty("EEWidget.DocumentCentreSearchService", EECore.Registrations.INTEGRATION_CONTEXT)
  private integrationContext: EECore.Integration.Context;

  constructor(location: Location, contentServiceHelper: EECore.Helpers.ContentServiceHelper, httpClient: EECore.HttpClient, integrationContext: EECore.Integration.Context) {
    this.location = location;
    this.contentServiceHelper = contentServiceHelper;
    this.httpClient = httpClient;
    this.integrationContext = integrationContext;
  }

  searchByKeywords(keywords: string) {
    const currentLobCode = this.contentServiceHelper.getLobCode();
    let lobParam = "";
    switch (currentLobCode) {
      case "IND":
        if (this.integrationContext.language.indexOf("fr") >= 0) {
          lobParam =
                        "&f:@doclineofbusinessreference=[Épargne%20et%20retraite%20individuelles,Assurance%20individuelle]";
        } else {
          lobParam =
                        "&f:@doclineofbusinessreference=[Individual%20Savings%20and%20Retirement,Individual%20Insurance]";

        }
        break;
      case "ERC":
        if (this.integrationContext.language.indexOf("fr") >= 0) {
          lobParam =
                        "&f:@doclineofbusinessreference=[Épargne%20et%20retraite%20collectives]";
        } else {
          lobParam =
                        "&f:@doclineofbusinessreference=[Group%20Savings%20and%20Retirement]";

        }
        break;
      case "AC":
        if (this.integrationContext.language.indexOf("fr") >= 0) {
          lobParam =
                        "&f:@doclineofbusinessreference=[Assurance%20collective]";
        } else {
          lobParam =
                        "&f:@doclineofbusinessreference=[Group%20Insurance]";

        }
        break;
      default:
    }

    keywords = encodeURIComponent(keywords.replace(/[<>']/g, " "));
    this.location.assign(`/cw/document-centre#q=${keywords}${lobParam}`);
  }

  isSearchEnabled(): EECore.Promise<boolean, boolean> {
    const url = `/sitecore/api/layout/render/jss?item=/404&sc_lang=${this.integrationContext.language.substr(0, 2)}&sc_apikey=${SITECORE_API_KEY}&sc_site=${this.integrationContext.experience.cwSiteName}`;
    const request = this.httpClient.get<string>(url, false);

    //When receive 2xx, it means the api is working, so Sitecore is Up (always return 404 in local due to bad url)
    return new EECore.Promise<boolean, boolean>((resolve) => {
      request.then(() => {
        resolve(true);
      }).catch(() => {
        resolve(false);
      });
    });
  }
}